import { MsalService } from '@azure/msal-angular';
import { ProfileManagerService } from './../../../../custom-shared/services/profile-manager.service';
import { SharedVariable } from './../../../../custom-shared/util/shared-variable';
import { UserService } from '@services-api/user.service';
import { MasterClienteCreateUserService } from '@app/features/master/master-cliente/cliente-criar-usuario-stepper/master-cliente-create-user.service';
import { Status } from './../../../../core/models/enums/status.enum';
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { PermissionGroup } from '@app/auth/services/custom-authentication.service';
import { User } from '@app/core/models/user-update-master.model';
import { ConfirmBoxColor } from '@app/custom-shared/components/alerts/confirm-box/confirm-box.component';
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service';
import { PromptBoxColor } from '@app/custom-shared/components/alerts/prompt-box/prompt-box.component';
import { CaceisIcons } from '@app/custom-shared/components/icons/caceis-icon/caceis-icon.component';
import { AppScreenBase } from '@app/custom-shared/util/app-screen-base';
import { AppScreenUtil } from '@app/custom-shared/util/app-screen-util';
import { UserStatus } from '@app/shared/models/user-status';
import { Language } from '@models/enums/language.enum';
import { Nationality } from '@models/enums/nationality.enum';
import { FeatureService } from '@services/feature/feature.service';
import { get } from 'lodash';
import { Observable } from 'rxjs';
import { InvestmentGroup } from '../cliente-grupo-investimento/cliente-grupo-investimento.model';
import { MasterClienteEditarUsuarioService } from './cliente-editar-usuario.service';
import { ClienteEditarUsuarioUtil } from './util/cliente-editar-usuario-util';

@Component({
  selector: 'app-master-cliente-editar-usuario',
  templateUrl: './cliente-editar-usuario.component.html',
  styleUrls: ['./cliente-editar-usuario.component.scss'],
})
export class MasterClienteEditarUsuarioComponent extends AppScreenBase
  implements OnInit {
  isNewSso: boolean = false;
  protected onClose(): void { }

  nationalityValues$: Observable<any>;
  languageValues$: Observable<any>;
  user: User;
  statusList = [];
  selectedStatus: string;
  utilForm: ClienteEditarUsuarioUtil;
  caceisIcons = CaceisIcons;
  disableUserSSO: boolean = false;
  val:any
  form: FormGroup;
  form2: FormGroup;
  form3: FormGroup;

  institutionOwners: any;

  @ViewChild('stepper', { static: false }) stepper: MatHorizontalStepper;

  constructor(
    private featureService: FeatureService,
    private repository: MasterClienteEditarUsuarioService,
    private snackBarService: DialogBoxService,
    public dialogRef: MatDialogRef<MasterClienteEditarUsuarioComponent>,
    private createUserService: MasterClienteCreateUserService,
    private userService: UserService,
    private shared: SharedVariable,
    private msalService: MsalService,
    private profileService: ProfileManagerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super();
  }

  ngOnInit() {
    // Criação dos formularios de criar usuario
    this.form = this.createForm();
    this.form2 = this.createForm2();
    this.form3 = this.createForm3();

    this.utilForm = new ClienteEditarUsuarioUtil(this.form);
    const payload = `{"id": "${this.data.id}"}`;
    this.repository.getUserById(payload).subscribe((userJson: User) => {
      // if (userJson.userSso != null) {
      //   this.form.controls['userSso'].disable();
      // }
      userJson.passport = userJson.passport ? userJson.passport : userJson.documentNumber;
      this.selectedStatus = userJson.status;
      this.institutionOwners = userJson.institutionOwners;
      // Carrega lista de status
      this.repository.listStatus().subscribe(result => {
        this.statusList = result.map(item => {
          item = this.featureService.translatorService.translateEnumItem(item, 'UserStatus')
          return { label: item, value: item };
        });

        if (
          this.selectedStatus == UserStatus.novoUsuario ||
          this.selectedStatus == UserStatus.bloqueado
        ) {
          this.form.get('status').clearValidators();
          this.form.get('reason').clearValidators();
        }
        this.user = userJson;
        if (this.user.permissionGroups[0]) {
          this.user.profileId = this.user.permissionGroups[0].id;
        }
        this.val=userJson
        this.updateFormValues();
      });
    });
  }

  get profileId() {
    return this.user.permissionGroups[0].id;
  }
  getValue(event){
    let val = event.target.value
    if (this.val.userSso != null) {
      if(event.target.value== ""){
        this.form.get('userSso').setValidators([Validators.required]);
        this.form.get('userSso').updateValueAndValidity();
      }else if(/^\s*$/.test(event.target.value)){
        this.form.get('userSso').setValidators([Validators.required,this.emptyFieldValidator(event.target.value)]);
        this.form.get('userSso').updateValueAndValidity();
      }else {
        this.form.get('userSso').clearValidators();
        this.form.get('userSso').updateValueAndValidity();
      }
    }
    return val;
  }
  emptyFieldValidator(val:any){
    return (control: FormControl): { [s: string]: boolean } => {
      if (control.value) {
      if (/\s/g.test(val)) {
      return { 'requiredField': true }
    }   
      }
      return null;
  }
}
  get isUserInactive() {
    /* return (
      this.user &&
      this.user.status &&
      (this.user.status == UserStatus.novoUsuario ||
        this.user.status == UserStatus.bloqueado)
    ); */
    return false
  }

  updateFormValues(): void {
    if (this.user == null || this.user == undefined) return;

    this.form.get('name').setValue(this.user.name);
    if (this.user.nationality) {
      this.form.get('nationality').setValue(this.user.nationality.toLowerCase());
    }
    if (this.isResidente()) {
      this.form.get('cpf').setValue(this.user.documentNumber);
    }
    if (this.user.passport) {
      this.form.get('passport').setValue(this.user.passport);
    }
    this.form.get('login').setValue(this.user.login);
    this.form.get('language').setValue(this.user.language);
    this.form.get('status').setValue(this.user.status)
    this.form.get('userSso').setValue(this.user.userSso)
    if (this.user.profileId) {
      this.form2.get('profileId').setValue(this.user.profileId);
    }
  }

  validateRadioButton(): void {
    if (this.islblCpfVisible()) {
      this.form.controls['cpf'].markAsTouched({ onlySelf: true });
    }

    if (this.ispassportnumberVisible()) {
      this.form.controls['passport'].markAsTouched({ onlySelf: true });
    }

    if (this.islblRgVisible()) {
      this.form.controls['rg'].markAsTouched({ onlySelf: true });
    }
  }

  /// Valida recursivamente todos os campos do form1(form)
  validateForm1(formGroup: FormGroup | FormArray): boolean {
    let isInvalid = this.form.invalid;

    if (isInvalid) {
      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);

        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
          this.validateForm1(control);
        }
      });
    }
    return !isInvalid;
  }

  validateAndGoToStep2() {
    let body = {}
    if (this.form.get('nationality').value == 'residente') {
      if (this.form.get('cpf').value) {
        let cpf = this.form.get('cpf').value
        cpf = cpf.replaceAll('.', '')
        cpf = cpf.replaceAll('-', '')
        body = {
          login: this.shared.userSso,
          name: this.form.get('userSso').value,
          cpf: cpf,
        }
      }
      const payload = `{"id": "${this.data.id}"}`
      if (this.user.userSso === null || this.user.userSso === '') {
        if (
          this.form.get('userSso').value != null &&
          this.form.get('userSso').value != '' &&
          this.form.get('userSso').value != this.user.userSso
        ) {
          this.createUserService
            .consultUserSSO(body)
            .toPromise()
            .then(res => {
              if (Number(res.result) < 100) {
                if (this.user.userSso === null) {
                  this.isNewSso = true
                } else {
                  this.isNewSso = false
                }
                if (this.validateForm1(null)) {
                  this.goToStep(1) // vai para o step 2
                }
              } else {
                setTimeout(() => {
                  this.featureService.translatorService
                    .translateEnumItem(res.messag, 'CaceisMessages')
                    .showError()
                }, 1500)
              }
            })
        } else {
          if (this.validateForm1(null)) {
            this.goToStep(1) // vai para o step 2
          }
        }
      } else {
        if (this.validateForm1(null)) {
          this.goToStep(1) // vai para o step 2
        }
      }
    } else {
      if (this.validateForm1(null)) {
        this.goToStep(1) // vai para o step 2
      }
    }



  }

  validateAndGoToStep3() {
    this.goToStep(2);
  }

  onSave() {
    let payload = {
      ...this.form.value,
      ...this.form2.value,
      ...this.form3.value,
    };
    let titlepopup, messagePopUp, cancelPopUp, savePopUp: string
    this.featureService.translatorService
      .getMessage('titleEditClient')
      .subscribe(val => {
        titlepopup = val
      })
    this.featureService.translatorService
      .getMessage('messageEditClient')
      .subscribe(val => {
        messagePopUp = val
      })
    this.featureService.translatorService
      .getMessage('cancelConfirm')
      .subscribe(val => {
        cancelPopUp = val
      })
    this.featureService.translatorService
      .getMessage('saveConfirm')
      .subscribe(val => {
        savePopUp = val
      })
    this.appDialog.confirmBox({
      lblTitle: titlepopup,
      lblSubtitle: messagePopUp,
      color: ConfirmBoxColor.error,
      lblCancelButton: cancelPopUp,
      lblConfirmButton: savePopUp,
      onConfirm: async () => {
        //console.log(this.form3.value.investmentGroups);
        this.updateUser();
        // this.repository.updateUser(payload).toPromise();
      },
    });
  }

  isMasterBO() {
    return this.profileService.isMasterBO();
  }

  updateUser() {
    let userName, wasSavedMsg, oUserName, alreadyExistsMsg: string
    const user = new User();

    if (this.form.value.cpf != null) {
      let cpf = this.form.value.cpf.replace(/\D/g, '')
      user.cpf = cpf;
    }
    user.reason = this.form.value.reason;
    user.language = this.form.value.language;
    user.login = this.form.value.login;
    user.name = this.form.value.name;
    user.userSso = this.form.value.userSso
    user.nationality = this.form.value.nationality;
    if (this.form.value.passport != null)
      user.passport = this.form.value.passport;
    user.status = this.form.value.status;
    if (this.form3.value.investmentGroups != null) {
      this.form3.value.investmentGroups = this.form3.value.investmentGroups.filter(res => res != null)
      this.form3.value.investmentGroups
        ? (user.investmentGroups = (this.form3.value
          .investmentGroups as InvestmentGroup[]).map(item => {
            return { id: item.id };
          }))
        : user?.investmentGroups?.map(item => { return { id: item.id } });

    }
    user.permissionGroups = [{ id: this.form2.value.profileId }];
    user.profileId = this.form2.value.profileId;
    user.institutionOwners = this.institutionOwners;
    this.featureService.translatorService.getMessage('userName').subscribe(
      data => userName = data
    )
    this.featureService.translatorService.getMessage('wasSaved').subscribe(
      data => wasSavedMsg = data
    )
    this.featureService.translatorService.getMessage('o-userName').subscribe(
      data => oUserName = data
    )
    this.featureService.translatorService.getMessage('ProfileNameDuplicatedEnd').subscribe(
      data => alreadyExistsMsg = data
    )
    let profileId = this.form2.value.profileId
    if (this.form.controls['userSso'].value != null  && this.form.get('nationality').value == "residente") {
      let perfil = ""
        if(this.isMasterBO()) {
          perfil = "3"
        } else {
          perfil = "4"
        }
        Object.assign(user,{perfil: perfil})
        if(this.isNewSso == true) {

          this.createUserService.createUserSSO(user, this.shared.userSso).toPromise()
          .then(res => {
            if (Number(res.result) < 100) {
              this.repository.updateMasterUser(user).then(() => {
              console.log("updated")
              })
              setTimeout(() => {
                this.snackBarService.snackbarUtil.showSuccess(
                  userName + ` "${user.name}" ` + wasSavedMsg,
                );
                 this.dialogRef.close();
              }, 1500)
            } else {
              setTimeout(() => {
                this.snackBarService.snackbarUtil.showError(
                  res.messag,
                );
              }, 1500)

            }

          })
        } else {

          let userSso = this.form.get('userSso').value
          this.createUserService.updateUserSSO(user, userSso,this.shared.userSso).toPromise().then(res => {
            if (Number(res.result) < 100) {
              this.repository.updateMasterUser(user).then((data) => {
              console.log("updated")
                if(data){
                  this.snackBarService.snackbarUtil.showSuccess(
                    userName + ` "${user.name}" ` + wasSavedMsg,
                  );
                   this.dialogRef.close();
                }
              })
              // setTimeout(() => {
              //   this.snackBarService.snackbarUtil.showSuccess(
              //     userName + ` "${user.name}" ` + wasSavedMsg,
              //   );
              //    this.dialogRef.close();
              // }, 1500)
            } else {
              setTimeout(() => {
                this.snackBarService.snackbarUtil.showError(
                  res.messag,
                );
              }, 1500)

            }

          })

        }

    } else {
      this.repository
      .updateMasterUser(user)
      .then((data) => {
        if(data){
          this.snackBarService.snackbarUtil.showSuccess(
            userName + ` "${user.name}" ` + wasSavedMsg,
          );
           this.dialogRef.close();
        }
        console.log("updated")
      })
      setTimeout(() => {
        // this.snackBarService.snackbarUtil.showSuccess(
        //   userName + ` "${user.name}" ` + wasSavedMsg,
        // );
        //  this.dialogRef.close();
      }, 1500)
    }
  }
  /// Avança um step da tela
  onNext(): void {
    this.stepper.next();
    AppScreenUtil.scrollAllModalToTop();
  }

  /// Retorna um step da tela
  onPrevious(): void {
    this.stepper.previous();
    AppScreenUtil.scrollAllModalToTop();
  }

  /// Muda para um step específico
  goToStep(index: number): void {
    this.stepper.selectedIndex = index;
    AppScreenUtil.scrollAllModalToTop();
  }

  getStepOneIcon(): string {
    if (this.stepper == null || this.stepper.selectedIndex == 0)
      return 'icon-step-1';
    if (this.stepper.selectedIndex == 1 || this.stepper.selectedIndex == 2)
      return 'icon-step-check';
  }

  getStepTwoIcon(): string {
    if (this.stepper == null || this.stepper.selectedIndex == 0)
      return 'icon-step-2 icon-step-disable ';
    if (this.stepper.selectedIndex == 1) return 'icon-step-2';
    if (this.stepper.selectedIndex == 2) return 'icon-step-check';
  }

  getStepThreeIcon(): string {
    if (
      this.stepper == null ||
      this.stepper.selectedIndex == 0 ||
      this.stepper.selectedIndex == 1
    )
      return 'icon-step-3 icon-step-disable ';
    if (this.stepper.selectedIndex == 2) return 'icon-step-3';
  }

  getProgressBarValue(): number {
    if (this.stepper == null) return 33.33;

    if (this.stepper.selectedIndex == 0) return 33.33;
    if (this.stepper.selectedIndex == 1) return 66.66;
    if (this.stepper.selectedIndex == 2) return 100;
  }

  createForm(): FormGroup {
    return this.featureService.formBuilder.group({
      nationality: [null, [Validators.required]],
      cpf: [null, [Validators.required]],
      passport: [null, []],
      name: [null, [Validators.required]],
      userSso: [null, []],
      login: [null, [Validators.required]],
      status: [null, [Validators.required]],
      reason: [null, [Validators.required]],
      language: [null, [Validators.required]],
    });
  }

  createForm2(): FormGroup {
    return this.featureService.formBuilder.group({
      profileId: [null, []],
      profile: [null, []],
    });
  }

  createForm3(): FormGroup {
    return this.featureService.formBuilder.group({
      investmentGroups: [null, []],
    });
  }

  getNationalityValues(): Observable<any> {
    return (this.nationalityValues$ =
      this.nationalityValues$ ||
      this.featureService.translatorService.enumValues(
        Nationality,
        'Nationality',
      ));
  }

  getLanguageValues(): Observable<any> {
    return (this.languageValues$ =
      this.languageValues$ ||
      this.featureService.translatorService.enumValues(Language, 'Language'));
  }

  getClientsGroup() {
    return this.featureService.formBuilder.group({
      name: [null, [Validators.required]],
    });
  }

  isReasonVisible(): boolean {
    // console.log(this.user.status, this.form.get('status').value);
    let result =
      this.form.get('status').value != null &&
      this.user.status != this.form.get('status').value &&
      'Inativo' != this.form.get('status').value;

    if (result !== true) {
      this.form.get('reason').clearValidators();
      this.form.get('reason').updateValueAndValidity();
    } else {
      this.form.get('reason').setValidators([Validators.required]);
    }
    return result;
  }

  isResidente(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    if (!nationality) return false;
    const result = nationality.toString().toLowerCase() != 'estrangeiro';
    return result;
  }

  islblCpfVisible(): boolean {
    return this.isResidente();
  }

  iscpfVisible(): boolean {
    const result = this.isResidente();

    if (result !== true) {
      this.form.get('cpf').clearValidators();
      this.form.get('cpf').updateValueAndValidity();
    } else {
      this.form.get('cpf').setValidators([Validators.required]);
    }
    return result;
  }

  ispassportnumberVisible(): boolean {
    return !this.isResidente();
  }

  ispassportVisible(): boolean {
    const result = !this.isResidente();

    if (result !== true) {
      this.form.get('passport').clearValidators();
      this.form.get('passport').updateValueAndValidity();
    } else {
      this.form.get('passport').setValidators([]);
    }
    return result;
  }

  islblRgVisible(): boolean {
    return this.isResidente();
  }

  isrgVisible(): boolean {
    const result = this.isResidente();

    if (result !== true) {
      this.form.get('rg').clearValidators();
      this.form.get('rg').updateValueAndValidity();
    } else {
      this.form.get('rg').setValidators([Validators.required]);
    }
    return result;
  }

  ispassportRequired(): boolean {
    const result = !this.isResidente();

    if (result) {
      this.form.get('passport').setValidators([Validators.required]);
    }
    return result;
  }

  islanguageReadOnly(): boolean {
    const language =
      get(this.form.value, 'language') || get(this.data, 'language');
    return language == 'português';
  }

  get clients(): FormArray {
    return this.form.get('clients') as FormArray;
  }

  onStatusChange(event): void {
    let disableUserTitle, unableToReactivateMsg, sureMsg, cancelMsg, desativarMsg, changeReasonMsg: string;
    if (this.user.status == event.value) {
      this.selectedStatus = event.value;
    }
    this.featureService.translatorService.getMessage('disableUser').subscribe(
      data => disableUserTitle = data
    )
    this.featureService.translatorService.getMessage('unableToReactivate').subscribe(
      data => unableToReactivateMsg = data
    )
    this.featureService.translatorService.getMessage('DeleteTextConfirm').subscribe(
      data => sureMsg = data
    )
    this.featureService.translatorService.getMessage('DeleteCancelConfirm').subscribe(
      data => cancelMsg = data
    )
    this.featureService.translatorService.getMessage('desativar').subscribe(
      data => desativarMsg = data
    )
    this.featureService.translatorService.getMessage('changeReason').subscribe(
      data => changeReasonMsg = data
    )
    if (this.user.status != event.value) {
      if (event.value.toLowerCase() == 'inativo'.toLowerCase() || event.value.toLowerCase() == 'inactive'.toLowerCase()) {
        this.appDialog.promptBox({
          lblTitle: disableUserTitle,
          lblSubtitle: unableToReactivateMsg + sureMsg,
          color: PromptBoxColor.error,
          lblCancelButton: cancelMsg,
          lblConfirmButton: desativarMsg,
          isRequired: true,
          placeHolder: changeReasonMsg,
          onCancel: () => {
            this.form.get('status').setValue(this.selectedStatus);
          },
          onConfirm: (reason: string) => {
            this.form
              .get('status')
              .setValue((this.selectedStatus = event.value));
              // block SSO
      if (this.form.get('status').value == "Inativo" && (this.form.get('userSso').value != null)) {
        let cpf = this.form.get('cpf').value
                cpf = cpf.replaceAll('.','')
                cpf = cpf.replaceAll('-','')
                this.user.cpf = cpf
        this.createUserService.blockUserSSO(this.user,this.shared.userSso).subscribe(res => {
          if(Number(res.result) < 100 ) {
            this.repository
              .inactivateUser(this.data.id, this.user, reason)
              .toPromise()
              .then(_ => {
                this.closeWithoutAsk();
              })
              .catch(_ => { });
          } else if (!res) {
            this.form.controls['status'].setErrors({'incorrect': true});
          } else {
            this.form.get('status').setValue('Ativo')
            this.user.status = 'Ativo'
            // this.closeWithoutAsk();
            setTimeout(() => {
              this.snackBarService.snackbarUtil.showError(
                res.messag,
              );
            }, 1500)
          }
        })
      } else {
        this.repository
              .inactivateUser(this.data.id, this.user, reason)
              .toPromise()
              .then(_ => {
                this.closeWithoutAsk();
              })
              .catch(_ => { });
      }

          },
        });
      } else {
        let changeStatusMsg, influencePermissionsMsg, saveMsg: string;
        this.featureService.translatorService.getMessage('changeStatus').subscribe(
          data => changeStatusMsg = data
        )
        this.featureService.translatorService.getMessage('influencePermissions').subscribe(
          data => influencePermissionsMsg = data
        )
        this.featureService.translatorService.getMessage('saveConfirm').subscribe(
          data => saveMsg = data
        )
        this.appDialog.confirmBox({
          lblTitle: changeStatusMsg,
          lblSubtitle: influencePermissionsMsg,
          color: ConfirmBoxColor.warn,
          lblCancelButton: cancelMsg,
          lblConfirmButton: saveMsg,
          onCancel: () => {
            this.form.get('status').setValue(this.selectedStatus);
          },
          onConfirm: () => {
            this.form
              .get('status')
              .setValue((this.selectedStatus = event.value));
          },
        });
      }
    }
  }

  closeWithoutAsk() {
    this.dialogRef.close();
  }

  close() {
    let titlepopup, subtitlepopup, cancelpopup, okpopup: string
    this.featureService.translatorService
      .getMessage('titleConfirm')
      .subscribe(val => {
        titlepopup = val
      })
    this.featureService.translatorService
      .getMessage('subtitleConfirm')
      .subscribe(val => {
        subtitlepopup = val
      })
    this.featureService.translatorService
      .getMessage('cancelConfirm')
      .subscribe(val => {
        cancelpopup = val
      })
    this.featureService.translatorService
      .getMessage('okConfirm')
      .subscribe(val => {
        okpopup = val
      })
    this.appDialog
      .confirmBox({
        lblTitle: titlepopup,
        lblSubtitle: subtitlepopup,
        lblCancelButton: cancelpopup,
        lblConfirmButton: okpopup,
        color: ConfirmBoxColor.error,
      })
      .afterClosed()
      .subscribe(result => {
        if (result == true) {
          this.dialogRef.close();
        }
      });
  }
  cpfValidate = param => {
    let val = param.replace(/[-.]/gi, '');
    val = val.replaceAll('_','')

    if (val.length === 11) {
     // this.isValidatedBycpfservice = false

      let isCpfExistent: boolean;
      let cpfToString = param
      cpfToString = cpfToString.replaceAll('.','')
      cpfToString = cpfToString.replaceAll('-','')
      let payload = { cpf: cpfToString };
     
      let checkCPFService: Observable<any> = this.createUserService.checkCpf(payload);
      checkCPFService.subscribe(response => {
        isCpfExistent = response.isValidCpf;
        if (isCpfExistent && cpfToString!= this.user.cpf) {
     //     this.isValidatedBycpfservice = false
          this.form.controls['cpf'].setErrors({ invalid: true });
     //     this.customErrorMessage = 'CPF já cadastrado';
          return { invalid: true };
        }
       else if(this.checkCpfValidity(val)){
        this.form.controls['cpf'].setErrors({ invalid: true });
      //  this.customErrorMessage = 'CPF inválido';
        return { invalid: true };
        }
         else {
       //   this.isValidatedBycpfservice = true
          this.form.controls['cpf'].setErrors(null);

        }
      });
    }
    else{
     // this.isValidatedBycpfservice = false
          this.form.controls['cpf'].setErrors({ invalid: true });
        //  this.customErrorMessage = 'CPF já cadastrado';
          return { invalid: true };
    }

 
  };

  checkCpfValidity(val){
    if (
      val == null ||
      val.length < 11 ||
      val == '00000000000' ||
      val == '11111111111' ||
      val == '22222222222' ||
      val == '33333333333' ||
      val == '44444444444' ||
      val == '55555555555' ||
      val == '66666666666' ||
      val == '77777777777' ||
      val == '88888888888' ||
      val == '99999999999'
    ) {
      this.form.controls['cpf'].setErrors({ invalid: true });
      //this.customErrorMessage = 'CPF inválido';
      return  true ;
    }

    let add = 0;
    for (let i = 0; i < 9; i++) add += parseInt(val.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(val.charAt(9))) {
      this.form.controls['cpf'].setErrors({ invalid: true });
     // this.customErrorMessage = 'CPF inválido';
      return  true 
    }
    add = 0;
    for (let i = 0; i < 10; i++) add += parseInt(val.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(val.charAt(10))) {
      this.form.controls['cpf'].setErrors({ invalid: true });
     // this.customErrorMessage = 'CPF inválido';
       true 
    }
    // this.form.controls['cpf'].setErrors(null);
   // this.customErrorMessage = '';
    return  false 
  }
}
